import { __decorate } from "tslib";
import { Mixins, Component, Watch } from 'vue-property-decorator';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import PageTitle from '@/components/v2/PageTitle.vue';
import AdsStepIndicator from '@/components/v3/ads_manager/AdsStepIndicator';
import SelectAdAccount from '@/views/v3/ads_manager/SelectAdAccount.vue';
import SelectCampaign from '@/views/v3/ads_manager/SelectCampaign.vue';
import SelectAdSet from '@/views/v3/ads_manager/SelectAdSet.vue';
import CreateAd from '@/views/v3/ads_manager/CreateAd.vue';
import StepsHeaderIndicator from '@/views/v3/StepsHeaderIndicator.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let CreateAdSteps = class CreateAdSteps extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin, WindowSizeListener, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.options = [
            { value: 1, text: 'Select Ad Account' },
            { value: 2, text: 'Select Ad Campaign' },
            { value: 3, text: 'Select Ad Set' },
            { value: 4, text: 'Create Ad' },
        ];
        this.selectedOption = this.options[0].value;
        this.checkValidation = false;
        this.showMobilePreview = false;
    }
    proceedToNext() {
        this.selectedOption += 1;
    }
    validationChecker() {
        this.checkValidation = true;
    }
    proceedToPrevious() {
        this.selectedOption -= 1;
    }
    goBackToAdsManager() {
        if (this.showMobilePreview) {
            this.showMobilePreview = false;
        }
        else {
            this.$router.push({
                name: 'ads-manager',
                params: { uuid: this.appUUID, to: 'ads-manager' },
            });
        }
    }
    toggleMobilePreview() {
        this.showMobilePreview = !this.showMobilePreview;
    }
    onResize() {
        if (this.smAndUp) {
            this.showMobilePreview = false;
        }
    }
};
__decorate([
    Watch('window.width')
], CreateAdSteps.prototype, "onResize", null);
CreateAdSteps = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
            AdsStepIndicator,
            PageTitle,
            SelectAdAccount,
            SelectCampaign,
            SelectAdSet,
            CreateAd,
            StepsHeaderIndicator,
        },
    })
], CreateAdSteps);
export default CreateAdSteps;
